import styled from 'styled-components';
import { FlexBox, FInter, Colors } from '@brg/ui';
import { LayoutConst } from 'core/modules';
import ResizedImageEnhanced from 'shared/components/ResizedImageEnhanced/ResizedImageEnhanced';
import { css } from 'styled-components';
import { BTagsGrid } from "../../../core/components";
import { HSESansTitleCoolEpicMegoGena } from "../../../_deziiign/hsedesign/components/IndexTitle";
import { Description } from "../../../shared/pages/explore/styles";
import { ShowMoreContent } from "../../../shared/pages/designer/styles";

interface CompetitionGridItemProps {
    isActual: boolean
}

interface IProps {
    isMobile: boolean;
}

export const SelectWrapper = styled(FlexBox).attrs({
  className: 'competition-sort-wrapper'
})<{isGeograffee?: boolean, themeType?: string}>`
.dropdown-element-popup {
  background: ${({isGeograffee, themeType}) => themeType === 'grey' ? "#3F4548" :  themeType === 'black' ? '#1f1f1f' : "#464645"};
  
  .dropdown-list-item {
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    color: #c5c6c7 !important;
    background: ${({isGeograffee, themeType }) => themeType === 'grey' ? "#3F4548" :  themeType === 'black' ? '#1f1f1f' : "#464645"};

    div {
      color: #c5c6c7 !important;
    }

    * {
      font-weight: 600 !important;
    }

    .active {
      color: #fefefe !important;
    }
    svg path {
      fill: ${Colors.galBlack61} !important;
    }
    .active ~ svg path {
      fill: #fefefe !important;
    }

    &:hover {
      background: #2c2c2b;
    }
  }
  .dropdown-list-item:hover {
    background: ${({theme, isGeograffee}) => isGeograffee ? theme.mainDropdownStyles.hoverBG : '#2c2c2b'};
  }
}
`;

export const InterLogo = styled(FlexBox)`
  font-weight: 600;
  display: block;
  word-break: break-word;
  margin-bottom: 0px;
  text-align: left;
  font-family: Inter;
  font-size: 60px;
  line-height: 70px;
  font-style: normal;
  color: rgb(244, 244, 244);
  letter-spacing: -0.01em !important;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 43px;
    line-height: 51px;
  }

  @media (max-width: ${LayoutConst.screen.s -1}px) {
    font-size: 28px;
    line-height: 34px;
  }
`;

export const SearchLabel = styled(FInter.SmallText)`
    font-size: 17px;
    line-height: 22px;

    @media(max-width: ${LayoutConst.screen.md}px) {

    }

`;

//<CompetitionGridItemProps>`
export const CompetitionGridItem = styled(FlexBox)<{ isMainPage?: boolean, isProfile?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  position: relative;
  //justify-content: center;
  // gap: 12px;
  // margin-bottom: 12px;
  //transition: all 0.2s;
  //width: 100%;
  background-color: ${({ isProfile }) => isProfile ? '#f2f2f2' : '#fafafa'};
  //box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);

  width: ${LayoutConst.competitionCard.l.w + 'px'};
  // width: 100%;
  height: ${LayoutConst.competitionCard.l.h + 'px'};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    ${({ isMainPage }) => isMainPage ? 
    null
    : css`
      // width: 100%;
      width: ${LayoutConst.competitionCard.m.w + 'px'};
      height: ${LayoutConst.competitionCard.m.h + 'px'};
    `}
  }

  @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
    ${({ isMainPage }) => isMainPage ? css`
      width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
      // min-width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      // min-height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
      // max-width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      // max-height: ${LayoutConst.competitionCard.m.h + 23  + 'px'};
    ` :
     `height: ${LayoutConst.competitionCard.m.h + 'px'}`}
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    ${({ isMainPage }) => isMainPage ? css`
      width: ${LayoutConst.competitionCard.s.w + 'px'};
      height: ${LayoutConst.competitionCard.s.h + 'px'};
      // min-width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      // min-height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
      // max-width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      // max-height: ${LayoutConst.competitionCard.m.h + 23  + 'px'};
    ` : 
     css`
      height: ${LayoutConst.competitionCard.s.h + 'px'};
      width: ${LayoutConst.competitionCard.s.w + 'px'};
     `}
  }

  // @media (max-width: ${LayoutConst.screen.md + 'px'}) {
  //   ${({ isMainPage }) => isMainPage ? null : css`
  //     // width: ${LayoutConst.competitionCard.m.w + 'px'};
  //     height: ${LayoutConst.competitionCard.m.h + 'px'};
  //     // min-width: ${LayoutConst.competitionCard.m.w + 'px'};
  //     min-height: ${LayoutConst.competitionCard.m.h + 'px'};
  //     // max-width: ${LayoutConst.competitionCard.m.w + 'px'};
  //     max-height: ${LayoutConst.competitionCard.m.h + 'px'};
  //     width: 50%;
  //     min-width: auto;
  //     max-width: none;
  //     margin-bottom: 0;

  //     .image-container {
  //       width: 50%;
  //       height: 100%;
  //     }
  //   `}
  // }

  // @media (max-width: ${LayoutConst.screen.s + 'px'}) {
  //   width: ${LayoutConst.competitionCard.s.w + 'px'};
  //   height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   min-width: ${LayoutConst.competitionCard.s.w + 'px'};
  //   min-height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   max-width: ${LayoutConst.competitionCard.s.w + 'px'};
  //   max-height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   margin-bottom: 0;
  // }

    // @media (min-width: ${LayoutConst.screen.s + 'px'}) {
    //     width: ${LayoutConst.competitionCard.s.w + 'px'};
    //     height: ${LayoutConst.competitionCard.s.h + 'px'};
    //     min-width: ${LayoutConst.competitionCard.s.w + 'px'};
    //     min-height: ${LayoutConst.competitionCard.s.h + 'px'};
    //     max-width: ${LayoutConst.competitionCard.s.w + 'px'};
    //     max-height: ${LayoutConst.competitionCard.s.h + 'px'};
    //     gap: 8px;
    //   }
    
      // @media (min-width: ${LayoutConst.screen.m + 'px'}) {
      //   width: ${LayoutConst.competitionCard.m.w + 'px'};
      //   height: ${LayoutConst.competitionCard.m.h + 'px'};
      //   min-width: ${LayoutConst.competitionCard.m.w + 'px'};
      //   min-height: ${LayoutConst.competitionCard.m.h + 'px'};
      //   max-width: ${LayoutConst.competitionCard.m.w + 'px'};
      //   max-height: ${LayoutConst.competitionCard.m.h + 'px'};
      // }
    
      // @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
      //   width: ${LayoutConst.competitionCard.l.w + 'px'};
      //   height: ${LayoutConst.competitionCard.l.h + 'px'};
      //   min-width: ${LayoutConst.competitionCard.l.w + 'px'};
      //   min-height: ${LayoutConst.competitionCard.l.h + 'px'};
      //   max-width: ${LayoutConst.competitionCard.l.w + 'px'};
      //   max-height: ${LayoutConst.competitionCard.l.h + 'px'};
      // }
    
      @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) { // На 768px проблема "поехавшего грида сохранялась - 767 норм
        ${() => {
          const width = 100;
          const padding = 20;
          const calculatedWidth = `calc(${width}vw - ${padding}px)`;
          const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
          return css`
            // gap: 3px;
            width: ${calculatedWidth};
            height: ${calculatedHeight};
            max-width: ${calculatedWidth};
            max-height: ${calculatedHeight};
            min-width: ${calculatedWidth};
            min-height: ${calculatedHeight};

            .image-container {
              width: auto;
              height: auto;
            }
          `}
        }
      }


`;

export const CompetitionGridItemNotAuto = styled(FlexBox)<CompetitionGridItemProps>`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    // margin-bottom: 35px;
    transition: all 0.2s;
    width: 100%;
    margin-bottom: 56px;
    :hover {
        opacity: 0.7;
    }

     @media (max-width: ${LayoutConst.screen.md + 'px'}) {
       margin-bottom: 24px;
   }
`;

export const CompetitionGridItemWrapper = styled(FlexBox)<{ isModal?: boolean, isSelected?: boolean }>`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-start;

    //width: 100%;
    //margin-bottom: 42px;

    // @media (min-width: ${LayoutConst.screen.s + 'px'}) {
    //     margin-bottom: 0px;
    // }

    
`;

export const CompetitionBgWrapper = styled.div<{bgColor?: string | undefined}>`
  background: ${p => p?.bgColor ?? p.theme.competition.bg};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

export const CompetitionShowMoreContent = styled(ShowMoreContent)`
  color: ${p => p.theme.competition.mainText};
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
  width: 100%;

  @media (min-width: ${LayoutConst.screen.m + 'px'}) {
    max-width: 712px;
    width: 100%;
  }
  
  @media (max-width:  ${LayoutConst.screen.m - 1 + 'px'}) {
    font-size: 13px;
    line-height: 16px;
  }
  
  @media (min-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    max-width: 100%;
    width: 100%;
  }
`


export const CompetitionLogo = styled(HSESansTitleCoolEpicMegoGena)<{smallOffset?: boolean}>`
  color: ${p => p.theme.competition.mainText};
  text-align: left;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 43px;
    line-height: 51px;
  }
  
  @media (min-width: ${LayoutConst.screen.s + 'px'}) {
    text-align: left;
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 28px;
            line-height: 34px;
  }
`
export const CompetitionDescription = styled(Description)`
  Color: ${p => p.theme.competition.mainText};
`
export const CompetitionContainer = styled.div.attrs({ className: 'grid-w' })<{ isTagPage?: boolean, isProfile?: boolean}>`
  display: grid;
  margin-top: ${({isProfile}) => isProfile ? '0px' : '24px'};

  grid-template-columns: repeat(2, ${LayoutConst.competitionCard.l.w + 'px'});
  gap: ${LayoutConst.projectCardGap.l + 'px'};
  row-gap: ${LayoutConst.projectCardGap.l * 2 + 'px'};
  padding-bottom: 16px;

  @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
    grid-template-columns: repeat(2, ${LayoutConst.competitionCard.m.w + 28 + 'px'});
    gap: ${LayoutConst.projectCardGap.m + 'px'};
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    grid-template-columns: repeat(2, ${LayoutConst.competitionCard.s.w + 'px'});
    gap: ${LayoutConst.projectCardGap.l + 'px'} 16px;
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  }

  @media (max-width: ${LayoutConst.screen.s + 'px'}) {
    grid-template-columns: repeat(2, ${LayoutConst.competitionCard.s.w + 'px'});
    gap: 16px;
    margin-top: ${({ isTagPage }) => isTagPage ? '24px' : '32px'};
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    grid-template-columns: repeat(1, 100%);
    gap: 16px;
    margin-top: 16px;
  }

  @media (max-width: 320px) {
    grid-template-columns: repeat(1, 100%);
    gap: 32px 10px;
  }
`;

export const CompetitionContainerNotAuto = styled.div<IProps>`

    width: 100%;
    position: relative;
    display: block;
    
    margin: ${p => p.isMobile ? "24px 0 32px 0" : "32px 0 104px 0"};

    ${CompetitionGridItem}:not(:first-child) {
        margin-top: 40px;

        @media(max-width:${LayoutConst.screen.md}px) {
            margin-top: 24px;
        }
    }
`;



export const StyledImgNotAuto = styled.img`
    min-height: 62px;

    // @media(max-width:${LayoutConst.screen.md}px) {
    //     height: 62px;
    // }
    
`;



export const StyledImg = styled(ResizedImageEnhanced)<{ isMainPage?: boolean, isWideProject?: boolean }>`
  //position: absolute;
  flex-shrink: 0;
  //top: 0;
  //left: 0;

  height: ${LayoutConst.competitionCard.l.h + 'px'};
  width: ${((LayoutConst.competitionCard.l.w) / 2) + 'px'};
  ${({ isWideProject }) => !isWideProject ? null : css`
      background: #151514;
      img { 
        object-fit: contain;
        object-position: top;
      }
    `}
  

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ isMainPage }) => isMainPage ? null : css`
      height: ${LayoutConst.competitionCard.m.h + 'px'};
      width: ${((LayoutConst.competitionCard.m.w - 24) / 2) + 'px'};
    `}
  }

  @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
    ${({ isMainPage }) => isMainPage ? css`
      height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
      width: ${((LayoutConst.competitionCard.m.w - 12) / 2) + 'px'};
    ` :
    css`
      width: ${(LayoutConst.competitionCard.m.w - 12) / 2}px;
      height: ${LayoutConst.competitionCard.m.h}px;
    `
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    ${({ isMainPage }) => isMainPage ? css`
      height: ${LayoutConst.competitionCard.s.h + 'px'};
      width: ${((LayoutConst.competitionCard.s.w - 12) / 2) + 'px'};
    ` : 
    css`
      width: ${(LayoutConst.competitionCard.s.w - 12) / 2}px;
      height: ${LayoutConst.competitionCard.s.h}px;
    `
  }

  // @media (max-width: ${LayoutConst.screen.md + 'px'}) {
  //   ${({ isMainPage }) => isMainPage ? null : css`
  //     width: 100%;
  //     height: ${LayoutConst.competitionCard.m.h + 'px'};

  //     img {
  //       object-fit: fill;
  //     }
  //   `}
  // }

  // @media (max-width: ${LayoutConst.screen.s + 'px'}) {
  //   height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   width: ${((LayoutConst.competitionCard.s.w - 4) / 2) + 'px'};
  // }


  // @media (min-width: ${LayoutConst.screen.s + 'px'}) {
  //   height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   width: ${((LayoutConst.competitionCard.s.w - 4) / 2) + 'px'};
  // }

  // @media (min-width: ${LayoutConst.screen.m + 'px'}) {
  //     width: ${((LayoutConst.competitionCard.m.w - 12) / 2) + 'px'};
  //     height: ${LayoutConst.competitionCard.m.h + 'px'};
  // }

  // @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
  //     height: ${LayoutConst.competitionCard.l.h + 'px'};
  //     width: ${((LayoutConst.competitionCard.l.w - 12) / 2) + 'px'};
  // }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) { // На 768px проблема "поехавшего грида сохранялась - 767 норм
  ${() => {
      const width = 100;
      const padding = 20;
      const calculatedWidth = `calc(((${width}vw - ${padding}px) - 4px) / 2)`;
      const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
      return css`
      width: ${calculatedWidth};
      height: ${calculatedHeight};
      max-width: ${calculatedWidth};
      max-height: ${calculatedHeight};
      min-width: ${calculatedWidth};
      min-height: ${calculatedHeight};
      img {
        object-fit: cover;
      }
        
      `}
  }
   ${({ isWideProject }) => !isWideProject ? null : css`
      background: #151514;
      img { 
        object-fit: contain;
        object-position: top;
      }
    `}
  }

`

export const InfoBlock = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;

    @media(max-width:${LayoutConst.screen.md}px) {
        padding-top: 4px;
    }
`;

export const CompetitionInfo = styled.div<{isDeadLineSoon?: boolean, isMainPage?: boolean, hasLongWord?: boolean }>`
    display: flex;
    flex-direction: column;
    color: ${p => p?.isDeadLineSoon ? '#ED4040' : Colors.galBlack61};
    font-family: 'Inter';
    font-style: normal;
    justify-content: space-between;
    // padding: 16px 24px;
    padding: ${p => p?.hasLongWord ? '24px 14px 16px' : '24px 16px 16px'};
    color: #545453;

    height: ${LayoutConst.competitionCard.l.h + 'px'};
    width: 291px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      ${({ isMainPage }) => isMainPage ? null : css`
        height: ${LayoutConst.competitionCard.m.h + 'px'};
        // width: ${((LayoutConst.competitionCard.m.w + 24) / 2) + 'px'};
        // width: 100%;
        width: 221px;
      `}
      padding: 16px;
    }

    @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
      ${({ isMainPage }) => isMainPage ? css`
        height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
        // width: ${((LayoutConst.competitionCard.m.w - 12 + 28) / 2) + 'px'};
        padding: 12px;
      ` : 
      // null
      css`
        height: ${LayoutConst.competitionCard.m.h}px;
        // width: 100%;
      `}
    }

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
      ${({ isMainPage }) => isMainPage ? css`
        height: ${LayoutConst.competitionCard.s.h + 'px'};
        // width: ${((LayoutConst.competitionCard.s.w - 12) / 2) + 'px'};
        width: 100%;
      ` :
      css`
        height: ${LayoutConst.competitionCard.s.h}px;
        // width: 100%;
        width: 180px;
        // max-width: ${((LayoutConst.competitionCard.s.w - 12) / 2)}px;
      `}
      ${({ hasLongWord }) => hasLongWord ? css`
        padding: 16px 14px;
      ` : null}
    }

    // @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    //   ${({ isMainPage }) => isMainPage ? null : css`
    //     // width: 50%;
    //     // height: ${LayoutConst.competitionCard.m.h + 'px'};
    //   `}
    // }

    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
      height: ${LayoutConst.competitionCard.s.h + 'px'};
      // width: ${((LayoutConst.competitionCard.s.w - 4) / 2) + 'px'};
    }

  

  // @media (min-width: ${LayoutConst.screen.s + 'px'}) {
  //   height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   width: ${((LayoutConst.competitionCard.s.w - 4) / 2) + 'px'};
  // }

    // @media (min-width: ${LayoutConst.screen.m + 'px'}) {
    //     width: ${((LayoutConst.competitionCard.m.w - 12) / 2) + 'px'};
    //     height: ${LayoutConst.competitionCard.m.h + 'px'};
    // }

    // @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
    //     height: ${LayoutConst.competitionCard.l.h + 'px'};
    //     width: ${((LayoutConst.competitionCard.l.w - 12) / 2) + 'px'};
    // }

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) { // На 768px проблема "поехавшего грида сохранялась - 767 норм
      ${({ hasLongWord }) => hasLongWord ? css`
              padding: 16px;
        ` : null}  
    ${() => {
        const width = 100;
        const padding = 20;
        const calculatedWidth = `calc(((${width}vw - ${padding}px) - 4px) / 2)`;
        const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
        return css`
        // width: ${calculatedWidth};
        width: 100%;
        height: ${calculatedHeight};
        // max-width: ${calculatedWidth};
        max-height: ${calculatedHeight};
        min-width: ${calculatedWidth};
        min-height: ${calculatedHeight};
        `}
    }
    }
`;

export const CompetitionMonth = styled.div`
    width: 100%;
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    text-align: center;
    letter-spacing: -0.02em;
    margin-top: 8px;
    margin-bottom: 8px;
    text-transform: capitalize;

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-weight: 600;
        //font-size: 22px;
        //line-height: 28px;
        font-size: 5vw;
        line-height: 7vw;
        margin-bottom: 8px;
      }

/*      @media (max-width: ${LayoutConst.screen.sm + 'px'}) {
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0;
        margin-bottom: 8px;
      }*/

      @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0;
        margin-bottom: 8px;
      }
    
      @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        font-weight: 700;
        font-size: 22px;
        line-height: 28px;
        margin-bottom: 8px;
      }
    
      @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
        font-weight: 700;
        font-size: 20px;
        line-height: 25px;
        text-align: center;
        letter-spacing: -0.02em;
      }
`;

export const CompetitionDivider = styled.div`
    width: 100%;
    // border: 1px solid #545453;
    height: 1px;
    min-height: 1px;
    background-color: #545453;

  @media (max-width: ${LayoutConst.screen.s + 'px'}) {
    width: calc(100% - 16px);
    margin-left: 8px;
  }
`;

export const CompetitionDay = styled.div`
    width: 100%;
    font-weight: 600;
    font-size: 120px;
    line-height: 150px;
    text-align: center;
    letter-spacing: -0.02em;

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

        font-size: 80px;
        line-height: 80px;

      }

      @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
        font-weight: 600;
        font-size: 80px;
        line-height: 80px;
        text-align: center;
        letter-spacing: -0.02em;
      }

      @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        font-weight: 600;
        font-size: 70px;
        // line-height: 41px;
        letter-spacing: -0.02em;
      }

      // @media (max-width: ${LayoutConst.screen.s + 'px'}) {
      //   font-size: 34px;
      //   line-height: 41px;
      //   letter-spacing: 0;
      // }

      @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-weight: 600;
        letter-spacing: -0.02em;
        font-size: 10.6vw;
        line-height: 12.8vw;
    }
`;

export const CompetitionDeadline = styled.div`
    width: 100%;
    font-weight: 400;
    font-size: 20px;
    line-height: 25px;
    text-align: center;
    letter-spacing: -0.02em;
    margin-bottom: 4px;

/*
    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-size: 22px;
        line-height: 28px;
      }
*/

      @media (max-width: ${LayoutConst.screen.s + 'px'}) {
        font-weight: 400;
/*        font-size: 17px;
        line-height: 22px;*/
        font-size: 5vw;
        line-height: 7vw;
        letter-spacing: 0;
      }

      @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        font-weight: 400;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0;

      }
    
      @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        font-size: 22px;
        line-height: 28px;
      }
    
      @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
        font-weight: 400;
        font-size: 20px;
        line-height: 25px;
        text-align: center;
        letter-spacing: -0.02em;
      }
`;

export const NameWrapper = styled.div`
    width: 100%;
    left: calc(50% - 214.02px/2 - 472.99px);
    font-family: 'Inter';
    letter-spacing: -0.02em;
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    color: ${p => p.theme.competition.mainText};

    @media(max-width:${LayoutConst.screen.md}px) {
        font-size: 13px;
        line-height: 18px;
    }
`;

export const DescriptionWrapper = styled.div`
    width: 100%;
    left: calc(50% - 214.02px/2 - 178.99px);
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #151514;
`;

export const CompetitionDescriptionWrapper = styled(DescriptionWrapper)<{ minOffset?: boolean }>`
  display: flex;

  @media (max-width: ${LayoutConst.screen.m}px) {
    display: block;
    max-width: 712px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-width: 100%;
  }

  a {
    &:hover {
      color: #CDCDCD;
    }
  }
`

export const CompetitionTags = styled.div`
     padding-top: 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    width: 100%;

    a {
        color: #1F1F1F !important;

        &:hover {
            color: #1F1F1F !important;
        }
    }

    @media(max-width:${LayoutConst.screen.md}px) {
        letter-spacing: 0;
    }
    @media(max-width:${LayoutConst.screen.s}px) {
      // padding-top: 16px;
      // margin-bottom: 16px;
      margin-bottom: 8px;
    }
`;

export const WinnerTab = styled(FlexBox)`
    .dropdown-element-popup {

      .dropdown-list-item {
        svg path {
          fill: #151514 !important;
        }
      }
    }
`;

export const CompetitionTagsWrapper = styled(BTagsGrid)`
    
  margin-top: 16px;
  width: 100%;
  // height: 90px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  row-gap: 10px;
  position: relative;
  margin-bottom: 0;
  // padding-bottom: 4px;
  ::-webkit-scrollbar {
    height: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: #fff !important;
  }
  ::-webkit-scrollbar-track {
    background: ${p => p.theme.competition.bg};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    // height: 80px;
    height: 100%;
    margin-bottom: 0;
  }
  @media(max-width:${LayoutConst.screen.l}px) {
    margin-top: 10px;
  }
  @media(max-width:${LayoutConst.screen.md}px) {
    padding-bottom: 0px;
    overflow-y: scroll;
  }
`;

export const CompetitionTitleWrapper = styled.div`
    color: ${p => p.theme.competition.mainText}
`;

export const TagsRightShadow = styled(FlexBox)<{isHidden?: boolean, mobileShrink?: boolean, isHseCompetition?: boolean, isMediiia?: boolean, isSuperPuperGames?: boolean;}>`
  height: 100%;
  width: 50px;

  ${({ mobileShrink, theme, isHseCompetition, isMediiia, isSuperPuperGames }) => mobileShrink && !isSuperPuperGames && css`
    width: ${isMediiia ? '50%' : '100%'};
    background: linear-gradient(270deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.shadowHseEnd : theme.dropdown.shadowEnd)} 20%, ${isHseCompetition ? theme.dropdown.shadowHse : theme.dropdown.shadow} 100%) !important;
    background: -webkit-linear-gradient(170deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.webkitShadowStart : theme.dropdown.webkitShadowStart)} 20%, ${isHseCompetition ? theme.dropdown.webkitShadowEnd : theme.dropdown.webkitShadowEnd} 100%);
    background: -moz-linear-gradient(270deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.shadowHseEnd : theme.dropdown.shadowEnd)} 20%, ${isHseCompetition ? theme.dropdown.shadowHse : theme.dropdown.shadow} 100%);
    background: -o-linear-gradient(270deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.shadowHseEnd : theme.dropdown.shadowEnd)} 20%, ${isHseCompetition ? theme.dropdown.shadowHse : theme.dropdown.shadow} 100%);
    background: -ms-linear-gradient(270deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.shadowHseEnd : theme.dropdown.shadowEnd)} 20%, ${isHseCompetition ? theme.dropdown.shadowHse : theme.dropdown.shadow} 100%);
    right: 4px;
  `};
  position: absolute;
  top: 0;
  transition: opacity 0.2s;
  opacity: ${p => p?.isHidden ? 0 : 1};
`;

export const TagsLeftShadow = styled(FlexBox)<{isHidden?: boolean}>`
    
  height: 100%;
  width: 50px;
  background: linear-gradient(90deg, ${p => p.theme.competition.bg} 0%, rgba(52, 52, 52, 0) 100%);
  position: absolute;
  left: 0;
  top: 0;
  transition: all 0.2s;
  opacity: ${p => p?.isHidden ? 0 : 1};
`;

export const FinishedBlock = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 43px;
  line-height: 51px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #FEFEFE;
  transform: rotate(-3deg);

  padding: 0px 16px;
  background: #ED4040;
  border-radius: 3px;

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    font-size: 22px;
    line-height: 28px;
    padding: 0px 12px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    font-size: 5.3vw;
    line-height: 7vw;
    padding: 0px 10px;
  }
`

export const CompetitionCardHeader = styled.div<{ weight?: number }>`
  font-weight: ${({ weight }) => `${weight || 600}`};
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  text-align: center;

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    font-size: 10px;
    line-height: 13px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    font-size: 8px;
    line-height: 12px;
  }
`;

export const CompetitionCardDescription = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    font-size: 9px;
    line-height: 13px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    font-size: 8px;
    line-height: 12px;
  }
`;

export const OverflowContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width 100%;
  padding: 10px 10px 0 10px;
`;

export const SelectedContainer = styled.div<{ visible?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width 100%;
  height: 100%;
  border: 5px solid #146DEE;
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'}; 
`;import styled from 'styled-components';
import { FlexBox, FInter, Colors } from '@brg/ui';
import { LayoutConst } from 'core/modules';
import ResizedImageEnhanced from 'shared/components/ResizedImageEnhanced/ResizedImageEnhanced';
import { css } from 'styled-components';
import { BTagsGrid } from "../../../core/components";
import { HSESansTitleCoolEpicMegoGena } from "../../../_deziiign/hsedesign/components/IndexTitle";
import { Description } from "../../../shared/pages/explore/styles";
import { ShowMoreContent } from "../../../shared/pages/designer/styles";

interface CompetitionGridItemProps {
    isActual: boolean
}

interface IProps {
    isMobile: boolean;
}

export const SelectWrapper = styled(FlexBox).attrs({
  className: 'competition-sort-wrapper'
})<{isGeograffee?: boolean, themeType?: string}>`
.dropdown-element-popup {
  background: ${({isGeograffee, themeType}) => themeType === 'grey' ? "#3F4548" :  themeType === 'black' ? '#1f1f1f' : "#464645"};
  
  .dropdown-list-item {
    font-size: 15px;
    line-height: 20px;
    font-weight: 600;
    color: #c5c6c7 !important;
    background: ${({isGeograffee, themeType }) => themeType === 'grey' ? "#3F4548" :  themeType === 'black' ? '#1f1f1f' : "#464645"};

    div {
      color: #c5c6c7 !important;
    }

    * {
      font-weight: 600 !important;
    }

    .active {
      color: #fefefe !important;
    }
    svg path {
      fill: ${Colors.galBlack61} !important;
    }
    .active ~ svg path {
      fill: #fefefe !important;
    }

    &:hover {
      background: #2c2c2b;
    }
  }
  .dropdown-list-item:hover {
    background: ${({theme, isGeograffee}) => isGeograffee ? theme.mainDropdownStyles.hoverBG : '#2c2c2b'};
  }
}
`;

export const InterLogo = styled(FlexBox)`
  font-weight: 600;
  display: block;
  word-break: break-word;
  margin-bottom: 0px;
  text-align: left;
  font-family: Inter;
  font-size: 60px;
  line-height: 70px;
  font-style: normal;
  color: rgb(244, 244, 244);
  letter-spacing: -0.01em !important;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 43px;
    line-height: 51px;
  }

  @media (max-width: ${LayoutConst.screen.s -1}px) {
    font-size: 28px;
    line-height: 34px;
  }
`;

export const SearchLabel = styled(FInter.SmallText)`
    font-size: 17px;
    line-height: 22px;

    @media(max-width: ${LayoutConst.screen.md}px) {

    }

`;

//<CompetitionGridItemProps>`
export const CompetitionGridItem = styled(FlexBox)<{ isMainPage?: boolean, isProfile?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  position: relative;
  //justify-content: center;
  // gap: 12px;
  // margin-bottom: 12px;
  //transition: all 0.2s;
  //width: 100%;
  background-color: ${({ isProfile }) => isProfile ? '#f2f2f2' : '#fafafa'};
  //box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);

  width: ${LayoutConst.competitionCard.l.w + 'px'};
  // width: 100%;
  height: ${LayoutConst.competitionCard.l.h + 'px'};

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

    ${({ isMainPage }) => isMainPage ? 
    null
    : css`
      // width: 100%;
      width: ${LayoutConst.competitionCard.m.w + 'px'};
      height: ${LayoutConst.competitionCard.m.h + 'px'};
    `}
  }

  @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
    ${({ isMainPage }) => isMainPage ? css`
      width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
      // min-width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      // min-height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
      // max-width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      // max-height: ${LayoutConst.competitionCard.m.h + 23  + 'px'};
    ` :
     `height: ${LayoutConst.competitionCard.m.h + 'px'}`}
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    ${({ isMainPage }) => isMainPage ? css`
      width: ${LayoutConst.competitionCard.s.w + 'px'};
      height: ${LayoutConst.competitionCard.s.h + 'px'};
      // min-width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      // min-height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
      // max-width: ${LayoutConst.competitionCard.m.w + 28 + 'px'};
      // max-height: ${LayoutConst.competitionCard.m.h + 23  + 'px'};
    ` : 
     css`
      height: ${LayoutConst.competitionCard.s.h + 'px'};
      width: ${LayoutConst.competitionCard.s.w + 'px'};
     `}
  }

  // @media (max-width: ${LayoutConst.screen.md + 'px'}) {
  //   ${({ isMainPage }) => isMainPage ? null : css`
  //     // width: ${LayoutConst.competitionCard.m.w + 'px'};
  //     height: ${LayoutConst.competitionCard.m.h + 'px'};
  //     // min-width: ${LayoutConst.competitionCard.m.w + 'px'};
  //     min-height: ${LayoutConst.competitionCard.m.h + 'px'};
  //     // max-width: ${LayoutConst.competitionCard.m.w + 'px'};
  //     max-height: ${LayoutConst.competitionCard.m.h + 'px'};
  //     width: 50%;
  //     min-width: auto;
  //     max-width: none;
  //     margin-bottom: 0;

  //     .image-container {
  //       width: 50%;
  //       height: 100%;
  //     }
  //   `}
  // }

  // @media (max-width: ${LayoutConst.screen.s + 'px'}) {
  //   width: ${LayoutConst.competitionCard.s.w + 'px'};
  //   height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   min-width: ${LayoutConst.competitionCard.s.w + 'px'};
  //   min-height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   max-width: ${LayoutConst.competitionCard.s.w + 'px'};
  //   max-height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   margin-bottom: 0;
  // }

    // @media (min-width: ${LayoutConst.screen.s + 'px'}) {
    //     width: ${LayoutConst.competitionCard.s.w + 'px'};
    //     height: ${LayoutConst.competitionCard.s.h + 'px'};
    //     min-width: ${LayoutConst.competitionCard.s.w + 'px'};
    //     min-height: ${LayoutConst.competitionCard.s.h + 'px'};
    //     max-width: ${LayoutConst.competitionCard.s.w + 'px'};
    //     max-height: ${LayoutConst.competitionCard.s.h + 'px'};
    //     gap: 8px;
    //   }
    
      // @media (min-width: ${LayoutConst.screen.m + 'px'}) {
      //   width: ${LayoutConst.competitionCard.m.w + 'px'};
      //   height: ${LayoutConst.competitionCard.m.h + 'px'};
      //   min-width: ${LayoutConst.competitionCard.m.w + 'px'};
      //   min-height: ${LayoutConst.competitionCard.m.h + 'px'};
      //   max-width: ${LayoutConst.competitionCard.m.w + 'px'};
      //   max-height: ${LayoutConst.competitionCard.m.h + 'px'};
      // }
    
      // @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
      //   width: ${LayoutConst.competitionCard.l.w + 'px'};
      //   height: ${LayoutConst.competitionCard.l.h + 'px'};
      //   min-width: ${LayoutConst.competitionCard.l.w + 'px'};
      //   min-height: ${LayoutConst.competitionCard.l.h + 'px'};
      //   max-width: ${LayoutConst.competitionCard.l.w + 'px'};
      //   max-height: ${LayoutConst.competitionCard.l.h + 'px'};
      // }
    
      @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) { // На 768px проблема "поехавшего грида сохранялась - 767 норм
        ${() => {
          const width = 100;
          const padding = 20;
          const calculatedWidth = `calc(${width}vw - ${padding}px)`;
          const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
          return css`
            // gap: 3px;
            width: ${calculatedWidth};
            height: ${calculatedHeight};
            max-width: ${calculatedWidth};
            max-height: ${calculatedHeight};
            min-width: ${calculatedWidth};
            min-height: ${calculatedHeight};

            .image-container {
              width: auto;
              height: auto;
            }
          `}
        }
      }


`;

export const CompetitionGridItemNotAuto = styled(FlexBox)<CompetitionGridItemProps>`
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    // margin-bottom: 35px;
    transition: all 0.2s;
    width: 100%;
    margin-bottom: 56px;
    :hover {
        opacity: 0.7;
    }

     @media (max-width: ${LayoutConst.screen.md + 'px'}) {
       margin-bottom: 24px;
   }
`;

export const CompetitionGridItemWrapper = styled(FlexBox)<{ isModal?: boolean, isSelected?: boolean }>`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: flex-start;

    //width: 100%;
    //margin-bottom: 42px;

    // @media (min-width: ${LayoutConst.screen.s + 'px'}) {
    //     margin-bottom: 0px;
    // }

    
`;

export const CompetitionBgWrapper = styled.div<{bgColor?: string | undefined}>`
  background: ${p => p?.bgColor ?? p.theme.competition.bg};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`

export const CompetitionShowMoreContent = styled(ShowMoreContent)`
  color: ${p => p.theme.competition.mainText};
  font-size: 20px;
  line-height: 28px;
  font-weight: 400;
  width: 100%;

  @media (min-width: ${LayoutConst.screen.m + 'px'}) {
    max-width: 712px;
    width: 100%;
  }
  
  @media (max-width:  ${LayoutConst.screen.m - 1 + 'px'}) {
    font-size: 13px;
    line-height: 16px;
  }
  
  @media (min-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    max-width: 100%;
    width: 100%;
  }
`


export const CompetitionLogo = styled(HSESansTitleCoolEpicMegoGena)<{smallOffset?: boolean}>`
  color: ${p => p.theme.competition.mainText};
  text-align: left;

  @media (max-width: ${LayoutConst.screen.l_12}px) {
    font-size: 43px;
    line-height: 51px;
  }
  
  @media (min-width: ${LayoutConst.screen.s + 'px'}) {
    text-align: left;
    width: 100%;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
            font-size: 28px;
            line-height: 34px;
  }
`
export const CompetitionDescription = styled(Description)`
  Color: ${p => p.theme.competition.mainText};
`
export const CompetitionContainer = styled.div.attrs({ className: 'grid-w' })<{ isTagPage?: boolean, isProfile?: boolean}>`
  display: grid;
  margin-top: ${({isProfile}) => isProfile ? '0px' : '24px'};

  grid-template-columns: repeat(2, ${LayoutConst.competitionCard.l.w + 'px'});
  gap: ${LayoutConst.projectCardGap.l + 'px'};
  row-gap: ${LayoutConst.projectCardGap.l * 2 + 'px'};
  padding-bottom: 16px;

  @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
    grid-template-columns: repeat(2, ${LayoutConst.competitionCard.m.w + 28 + 'px'});
    gap: ${LayoutConst.projectCardGap.m + 'px'};
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    grid-template-columns: repeat(2, ${LayoutConst.competitionCard.s.w + 'px'});
    gap: ${LayoutConst.projectCardGap.l + 'px'} 16px;
    padding-bottom: ${LayoutConst.projectCardGap.l + 'px'};
  }

  @media (max-width: ${LayoutConst.screen.s + 'px'}) {
    grid-template-columns: repeat(2, ${LayoutConst.competitionCard.s.w + 'px'});
    gap: 16px;
    margin-top: ${({ isTagPage }) => isTagPage ? '24px' : '32px'};
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    grid-template-columns: repeat(1, 100%);
    gap: 16px;
    margin-top: 16px;
  }

  @media (max-width: 320px) {
    grid-template-columns: repeat(1, 100%);
    gap: 32px 10px;
  }
`;

export const CompetitionContainerNotAuto = styled.div<IProps>`

    width: 100%;
    position: relative;
    display: block;
    
    margin: ${p => p.isMobile ? "24px 0 32px 0" : "32px 0 104px 0"};

    ${CompetitionGridItem}:not(:first-child) {
        margin-top: 40px;

        @media(max-width:${LayoutConst.screen.md}px) {
            margin-top: 24px;
        }
    }
`;



export const StyledImgNotAuto = styled.img`
    min-height: 62px;

    // @media(max-width:${LayoutConst.screen.md}px) {
    //     height: 62px;
    // }
    
`;



export const StyledImg = styled(ResizedImageEnhanced)<{ isMainPage?: boolean, isWideProject?: boolean }>`
  //position: absolute;
  flex-shrink: 0;
  //top: 0;
  //left: 0;

  height: ${LayoutConst.competitionCard.l.h + 'px'};
  width: ${((LayoutConst.competitionCard.l.w) / 2) + 'px'};
  ${({ isWideProject }) => !isWideProject ? null : css`
      background: #151514;
      img { 
        object-fit: contain;
        object-position: top;
      }
    `}
  

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    ${({ isMainPage }) => isMainPage ? null : css`
      height: ${LayoutConst.competitionCard.m.h + 'px'};
      width: ${((LayoutConst.competitionCard.m.w - 24) / 2) + 'px'};
    `}
  }

  @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
    ${({ isMainPage }) => isMainPage ? css`
      height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
      width: ${((LayoutConst.competitionCard.m.w - 12) / 2) + 'px'};
    ` :
    css`
      width: ${(LayoutConst.competitionCard.m.w - 12) / 2}px;
      height: ${LayoutConst.competitionCard.m.h}px;
    `
  }

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    ${({ isMainPage }) => isMainPage ? css`
      height: ${LayoutConst.competitionCard.s.h + 'px'};
      width: ${((LayoutConst.competitionCard.s.w - 12) / 2) + 'px'};
    ` : 
    css`
      width: ${(LayoutConst.competitionCard.s.w - 12) / 2}px;
      height: ${LayoutConst.competitionCard.s.h}px;
    `
  }

  // @media (max-width: ${LayoutConst.screen.md + 'px'}) {
  //   ${({ isMainPage }) => isMainPage ? null : css`
  //     width: 100%;
  //     height: ${LayoutConst.competitionCard.m.h + 'px'};

  //     img {
  //       object-fit: fill;
  //     }
  //   `}
  // }

  // @media (max-width: ${LayoutConst.screen.s + 'px'}) {
  //   height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   width: ${((LayoutConst.competitionCard.s.w - 4) / 2) + 'px'};
  // }


  // @media (min-width: ${LayoutConst.screen.s + 'px'}) {
  //   height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   width: ${((LayoutConst.competitionCard.s.w - 4) / 2) + 'px'};
  // }

  // @media (min-width: ${LayoutConst.screen.m + 'px'}) {
  //     width: ${((LayoutConst.competitionCard.m.w - 12) / 2) + 'px'};
  //     height: ${LayoutConst.competitionCard.m.h + 'px'};
  // }

  // @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
  //     height: ${LayoutConst.competitionCard.l.h + 'px'};
  //     width: ${((LayoutConst.competitionCard.l.w - 12) / 2) + 'px'};
  // }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) { // На 768px проблема "поехавшего грида сохранялась - 767 норм
  ${() => {
      const width = 100;
      const padding = 20;
      const calculatedWidth = `calc(((${width}vw - ${padding}px) - 4px) / 2)`;
      const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
      return css`
      width: ${calculatedWidth};
      height: ${calculatedHeight};
      max-width: ${calculatedWidth};
      max-height: ${calculatedHeight};
      min-width: ${calculatedWidth};
      min-height: ${calculatedHeight};
      img {
        object-fit: cover;
      }
        
      `}
  }
   ${({ isWideProject }) => !isWideProject ? null : css`
      background: #151514;
      img { 
        object-fit: contain;
        object-position: top;
      }
    `}
  }

`

export const InfoBlock = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 12px;

    @media(max-width:${LayoutConst.screen.md}px) {
        padding-top: 4px;
    }
`;

export const CompetitionInfo = styled.div<{isDeadLineSoon?: boolean, isMainPage?: boolean, hasLongWord?: boolean }>`
    display: flex;
    flex-direction: column;
    color: ${p => p?.isDeadLineSoon ? '#ED4040' : Colors.galBlack61};
    font-family: 'Inter';
    font-style: normal;
    justify-content: space-between;
    // padding: 16px 24px;
    padding: ${p => p?.hasLongWord ? '24px 14px 16px' : '24px 16px 16px'};
    color: #545453;

    height: ${LayoutConst.competitionCard.l.h + 'px'};
    width: 291px;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      ${({ isMainPage }) => isMainPage ? null : css`
        height: ${LayoutConst.competitionCard.m.h + 'px'};
        // width: ${((LayoutConst.competitionCard.m.w + 24) / 2) + 'px'};
        // width: 100%;
        width: 221px;
      `}
      padding: 16px;
    }

    @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
      ${({ isMainPage }) => isMainPage ? css`
        height: ${LayoutConst.competitionCard.m.h + 23 + 'px'};
        // width: ${((LayoutConst.competitionCard.m.w - 12 + 28) / 2) + 'px'};
        padding: 12px;
      ` : 
      // null
      css`
        height: ${LayoutConst.competitionCard.m.h}px;
        // width: 100%;
      `}
    }

    @media (max-width: ${LayoutConst.screen.m + 'px'}) {
      ${({ isMainPage }) => isMainPage ? css`
        height: ${LayoutConst.competitionCard.s.h + 'px'};
        // width: ${((LayoutConst.competitionCard.s.w - 12) / 2) + 'px'};
        width: 100%;
      ` :
      css`
        height: ${LayoutConst.competitionCard.s.h}px;
        // width: 100%;
        width: 180px;
        // max-width: ${((LayoutConst.competitionCard.s.w - 12) / 2)}px;
      `}
      ${({ hasLongWord }) => hasLongWord ? css`
        padding: 16px 14px;
      ` : null}
    }

    // @media (max-width: ${LayoutConst.screen.md + 'px'}) {
    //   ${({ isMainPage }) => isMainPage ? null : css`
    //     // width: 50%;
    //     // height: ${LayoutConst.competitionCard.m.h + 'px'};
    //   `}
    // }

    @media (max-width: ${LayoutConst.screen.s + 'px'}) {
      height: ${LayoutConst.competitionCard.s.h + 'px'};
      // width: ${((LayoutConst.competitionCard.s.w - 4) / 2) + 'px'};
    }

  

  // @media (min-width: ${LayoutConst.screen.s + 'px'}) {
  //   height: ${LayoutConst.competitionCard.s.h + 'px'};
  //   width: ${((LayoutConst.competitionCard.s.w - 4) / 2) + 'px'};
  // }

    // @media (min-width: ${LayoutConst.screen.m + 'px'}) {
    //     width: ${((LayoutConst.competitionCard.m.w - 12) / 2) + 'px'};
    //     height: ${LayoutConst.competitionCard.m.h + 'px'};
    // }

    // @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
    //     height: ${LayoutConst.competitionCard.l.h + 'px'};
    //     width: ${((LayoutConst.competitionCard.l.w - 12) / 2) + 'px'};
    // }

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) { // На 768px проблема "поехавшего грида сохранялась - 767 норм
      ${({ hasLongWord }) => hasLongWord ? css`
              padding: 16px;
        ` : null}  
    ${() => {
        const width = 100;
        const padding = 20;
        const calculatedWidth = `calc(((${width}vw - ${padding}px) - 4px) / 2)`;
        const calculatedHeight = `calc((${width}vw - ${padding}px) * 0.680)`;
        return css`
        // width: ${calculatedWidth};
        width: 100%;
        height: ${calculatedHeight};
        // max-width: ${calculatedWidth};
        max-height: ${calculatedHeight};
        min-width: ${calculatedWidth};
        min-height: ${calculatedHeight};
        `}
    }
    }
`;

export const CompetitionMonth = styled.div`
    width: 100%;
    font-weight: 700;
    font-size: 20px;
    line-height: 25px;
    text-align: center;
    letter-spacing: -0.02em;
    margin-top: 8px;
    margin-bottom: 8px;
    text-transform: capitalize;

    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-weight: 600;
        //font-size: 22px;
        //line-height: 28px;
        font-size: 5vw;
        line-height: 7vw;
        margin-bottom: 8px;
      }

/*      @media (max-width: ${LayoutConst.screen.sm + 'px'}) {
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0;
        margin-bottom: 8px;
      }*/

      @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        font-weight: 600;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0;
        margin-bottom: 8px;
      }
    
      @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        font-weight: 700;
        font-size: 22px;
        line-height: 28px;
        margin-bottom: 8px;
      }
    
      @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
        font-weight: 700;
        font-size: 20px;
        line-height: 25px;
        text-align: center;
        letter-spacing: -0.02em;
      }
`;

export const CompetitionDivider = styled.div`
    width: 100%;
    // border: 1px solid #545453;
    height: 1px;
    min-height: 1px;
    background-color: #545453;

  @media (max-width: ${LayoutConst.screen.s + 'px'}) {
    width: calc(100% - 16px);
    margin-left: 8px;
  }
`;

export const CompetitionDay = styled.div`
    width: 100%;
    font-weight: 600;
    font-size: 120px;
    line-height: 150px;
    text-align: center;
    letter-spacing: -0.02em;

      @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {

        font-size: 80px;
        line-height: 80px;

      }

      @media (max-width: ${LayoutConst.screen.l_12 + 'px'}) {
        font-weight: 600;
        font-size: 80px;
        line-height: 80px;
        text-align: center;
        letter-spacing: -0.02em;
      }

      @media (max-width: ${LayoutConst.screen.m + 'px'}) {
        font-weight: 600;
        font-size: 70px;
        // line-height: 41px;
        letter-spacing: -0.02em;
      }

      // @media (max-width: ${LayoutConst.screen.s + 'px'}) {
      //   font-size: 34px;
      //   line-height: 41px;
      //   letter-spacing: 0;
      // }

      @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-weight: 600;
        letter-spacing: -0.02em;
        font-size: 10.6vw;
        line-height: 12.8vw;
    }
`;

export const CompetitionDeadline = styled.div`
    width: 100%;
    font-weight: 400;
    font-size: 20px;
    line-height: 25px;
    text-align: center;
    letter-spacing: -0.02em;
    margin-bottom: 4px;

/*
    @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
        font-size: 22px;
        line-height: 28px;
      }
*/

      @media (max-width: ${LayoutConst.screen.s + 'px'}) {
        font-weight: 400;
/*        font-size: 17px;
        line-height: 22px;*/
        font-size: 5vw;
        line-height: 7vw;
        letter-spacing: 0;
      }

      @media (min-width: ${LayoutConst.screen.s + 'px'}) {
        font-weight: 400;
        font-size: 17px;
        line-height: 22px;
        letter-spacing: 0;

      }
    
      @media (min-width: ${LayoutConst.screen.m + 'px'}) {
        font-size: 22px;
        line-height: 28px;
      }
    
      @media (min-width: ${LayoutConst.screen.l_12 + 'px'}) {
        font-weight: 400;
        font-size: 20px;
        line-height: 25px;
        text-align: center;
        letter-spacing: -0.02em;
      }
`;

export const NameWrapper = styled.div`
    width: 100%;
    left: calc(50% - 214.02px/2 - 472.99px);
    font-family: 'Inter';
    letter-spacing: -0.02em;
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    color: ${p => p.theme.competition.mainText};

    @media(max-width:${LayoutConst.screen.md}px) {
        font-size: 13px;
        line-height: 18px;
    }
`;

export const DescriptionWrapper = styled.div`
    width: 100%;
    left: calc(50% - 214.02px/2 - 178.99px);
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 20px;
    color: #151514;
`;

export const CompetitionDescriptionWrapper = styled(DescriptionWrapper)<{ minOffset?: boolean }>`
  display: flex;

  @media (max-width: ${LayoutConst.screen.m}px) {
    display: block;
    max-width: 712px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-width: 100%;
  }

  a {
    &:hover {
      color: #CDCDCD;
    }
  }
`

export const CompetitionTags = styled.div`
     padding-top: 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 22px;
    letter-spacing: -0.02em;
    width: 100%;

    a {
        color: #1F1F1F !important;

        &:hover {
            color: #1F1F1F !important;
        }
    }

    @media(max-width:${LayoutConst.screen.md}px) {
        letter-spacing: 0;
    }
    @media(max-width:${LayoutConst.screen.s}px) {
      // padding-top: 16px;
      // margin-bottom: 16px;
      margin-bottom: 8px;
    }
`;

export const WinnerTab = styled(FlexBox)`
    .dropdown-element-popup {

      .dropdown-list-item {
        svg path {
          fill: #151514 !important;
        }
      }
    }
`;

export const CompetitionTagsWrapper = styled(BTagsGrid)`
    
  margin-top: 16px;
  width: 100%;
  // height: 90px;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  row-gap: 10px;
  position: relative;
  margin-bottom: 0;
  // padding-bottom: 4px;
  ::-webkit-scrollbar {
    height: 2px;
  }
  ::-webkit-scrollbar-thumb {
    background: #fff !important;
  }
  ::-webkit-scrollbar-track {
    background: ${p => p.theme.competition.bg};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    // height: 80px;
    height: 100%;
    margin-bottom: 0;
  }
  @media(max-width:${LayoutConst.screen.l}px) {
    margin-top: 10px;
  }
  @media(max-width:${LayoutConst.screen.md}px) {
    padding-bottom: 0px;
    overflow-y: scroll;
  }
`;

export const CompetitionTitleWrapper = styled.div`
    color: ${p => p.theme.competition.mainText}
`;

export const TagsRightShadow = styled(FlexBox)<{isHidden?: boolean, mobileShrink?: boolean, isHseCompetition?: boolean, isMediiia?: boolean, isSuperPuperGames?: boolean;}>`
  height: 100%;
  width: 50px;

  ${({ mobileShrink, theme, isHseCompetition, isMediiia, isSuperPuperGames }) => mobileShrink && !isSuperPuperGames && css`
    width: ${isMediiia ? '50%' : '100%'};
    background: linear-gradient(270deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.shadowHseEnd : theme.dropdown.shadowEnd)} 20%, ${isHseCompetition ? theme.dropdown.shadowHse : theme.dropdown.shadow} 100%) !important;
    background: -webkit-linear-gradient(170deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.webkitShadowStart : theme.dropdown.webkitShadowStart)} 20%, ${isHseCompetition ? theme.dropdown.webkitShadowEnd : theme.dropdown.webkitShadowEnd} 100%);
    background: -moz-linear-gradient(270deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.shadowHseEnd : theme.dropdown.shadowEnd)} 20%, ${isHseCompetition ? theme.dropdown.shadowHse : theme.dropdown.shadow} 100%);
    background: -o-linear-gradient(270deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.shadowHseEnd : theme.dropdown.shadowEnd)} 20%, ${isHseCompetition ? theme.dropdown.shadowHse : theme.dropdown.shadow} 100%);
    background: -ms-linear-gradient(270deg, ${isMediiia ? 'rgb(231, 231, 231)' : (isHseCompetition ? theme.dropdown.shadowHseEnd : theme.dropdown.shadowEnd)} 20%, ${isHseCompetition ? theme.dropdown.shadowHse : theme.dropdown.shadow} 100%);
    right: 4px;
  `};
  position: absolute;
  top: 0;
  transition: opacity 0.2s;
  opacity: ${p => p?.isHidden ? 0 : 1};
`;

export const TagsLeftShadow = styled(FlexBox)<{isHidden?: boolean}>`
    
  height: 100%;
  width: 50px;
  background: linear-gradient(90deg, ${p => p.theme.competition.bg} 0%, rgba(52, 52, 52, 0) 100%);
  position: absolute;
  left: 0;
  top: 0;
  transition: all 0.2s;
  opacity: ${p => p?.isHidden ? 0 : 1};
`;

export const FinishedBlock = styled.div`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 43px;
  line-height: 51px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #FEFEFE;
  transform: rotate(-3deg);

  padding: 0px 16px;
  background: #ED4040;
  border-radius: 3px;

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    font-size: 22px;
    line-height: 28px;
    padding: 0px 12px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    font-size: 5.3vw;
    line-height: 7vw;
    padding: 0px 10px;
  }
`

export const CompetitionCardHeader = styled.div<{ weight?: number }>`
  font-weight: ${({ weight }) => `${weight || 600}`};
  font-size: 17px;
  line-height: 22px;
  letter-spacing: -0.02em;
  text-align: center;

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    font-size: 10px;
    line-height: 13px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    font-size: 8px;
    line-height: 12px;
  }
`;

export const CompetitionCardDescription = styled.div`
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.m + 'px'}) {
    font-size: 9px;
    line-height: 13px;
  }

  @media (max-width: ${LayoutConst.screen.s - 1 + 'px'}) {
    font-size: 8px;
    line-height: 12px;
  }
`;

export const OverflowContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width 100%;
  padding: 10px 10px 0 10px;
`;

export const SelectedContainer = styled.div<{ visible?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width 100%;
  height: 100%;
  border: 5px solid #146DEE;
  visibility: ${({ visible }) => visible ? 'visible' : 'hidden'}; 
`;